/**
 * The base every API request is built on: the configured host (or, when it is empty, the page's own origin, where
 * nginx proxies the API) followed by the prefix, with no trailing slash. A host without a scheme gets `http://`.
 *
 * `ApiService.createURL` builds every request on it, and the embed snippet on the premise settings page hands the
 * same value to the elements as their `url` attribute. One rule for both means a malformed environment value behaves
 * the same in the app and in an embed, instead of working in one and breaking the other. See docs/embed-releases.md.
 */
export function apiBaseUrl(host: string, prefix: string, origin: string): string {
  let url = origin
  if (host !== '') {
    const sanitizedHost = host.replace(/\/$/, '')
    url = host.startsWith('http://') || host.startsWith('https://') ? sanitizedHost : `http://${sanitizedHost}`
  }

  if (prefix !== '') {
    url += `/${prefix.replace(/^\//, '').replace(/\/$/, '')}`
  }
  return url
}
